const requiredFields = ["owner_id", "name", "priority", "pipeline", "status"];

function validateTicketData() {
	let inputs = [
		...document.querySelectorAll(".form_create_ticket div.inputText"),
	];
	let inputsDates = [...document.querySelectorAll(".form_create_ticket input")];
	let selects = [...document.querySelectorAll(".form_create_ticket select")];
	let fields = {};

	inputs.forEach((input) => {
		fields[input.id] = input.textContent;
	});
	inputsDates.forEach((input) => {
		let value = input.value;
		if (input.type === "datetime-local" && value) {
			value = value.replace("T", " ");
		}
		fields[input.id] = value;
	});

	selects.forEach((select) => {
		let value = select.value;
		if (select.getAttribute("multiple") !== null) {
			const options = select.options;
			value = [];
			for (var i = 0, l = options.length; i < l; i++) {
				if (options[i].selected) {
					value.push(options[i].value);
				}
			}
		}
		fields[select.id] = value;
	});

	// if (requiredFields.some((field) => !fields[field])) {
	// 	return false;
	// }

	return fields;
}

export { validateTicketData };
